import React, { useState, useEffect } from 'react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import HeroSection from '../../components/public/HeroSection';
import FeaturesSection from '../../components/public/FeaturesSection';
import ProductsSection from '../../components/public/ProductsSection';
import TestimonialsSection from '../../components/public/TestimonialsSection';
import CTASection from '../../components/public/CTASection';
import ServicesSection from '../../components/public/ServicesSection';
import CompanyOverview from '../../components/public/CompanyOverview';
import VisionMission from '../../components/public/VisionMission';
import Timeline from '../../components/public/Timeline';
import CoreValues from '../../components/public/CoreValues';
import TeamSection from '../../components/public/TeamSection';
import StatsSection from '../../components/public/StatsSection';
import { publicApi } from '../../services/api';
import { parseSectionContent } from '../../utils/sectionContent';

const SECTION_COMPONENTS = {
  hero: HeroSection,
  features: FeaturesSection,
  services: ServicesSection,
  products: ProductsSection,
  testimonials: TestimonialsSection,
  cta: CTASection,
  overview: CompanyOverview,
  vision_mission: VisionMission,
  timeline: Timeline,
  core_values: CoreValues,
  team: TeamSection,
  stats: StatsSection,
  content: ({ content }) => (
    <section className="py-16 bg-white">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 prose">
        <div dangerouslySetInnerHTML={{ __html: content?.body || '' }} />
      </div>
    </section>
  ),
  gallery: ({ content }) => (
    <section className="py-16 bg-bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {content?.title && <h2 className="text-3xl font-extrabold text-center mb-4" style={{ fontFamily: "'Cabin', sans-serif" }}>{content.title}</h2>}
        {content?.subtitle && <p className="text-center text-gray-500 mb-8">{content.subtitle}</p>}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {(content?.images || []).map((img, i) => (
            <div key={i} className="aspect-square bg-gray-200 rounded-xl overflow-hidden">
              {img.url ? (
                <img src={img.url} alt={img.alt || ''} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-4xl">🖼️</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  ),
};

export default function HomePage() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await publicApi.getPage('home');
      const page = res.data?.data || res.data || null;
      setSections(page?.sections || []);
    } catch (err) {
      setError('Gagal memuat data. Silakan coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-light">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Memuat...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-light">
        <div className="text-center bg-white p-8 rounded-2xl shadow-lg max-w-md">
          <span className="text-4xl mb-4 block">⚠️</span>
          <p className="text-red-600 mb-4">{error}</p>
          <button onClick={fetchData} className="bg-brand text-navy px-6 py-2 rounded-full hover:bg-brand-dark transition-colors font-semibold">Coba Lagi</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      {sections.map((section) => {
        const Component = SECTION_COMPONENTS[section.type];
        const parsedContent = parseSectionContent(section.content);
        return Component ? <Component key={section.id} content={parsedContent} /> : null;
      })}
      <Footer />
    </div>
  );
}